import {CHECK_CONNECTION_FAILURE, CHECK_CONNECTION_SUCCESS, FAILURE_POSTFIX} from 'new-constants/api.constants';
import {SET_OFFLINE, SET_ONLINE} from 'new-constants/connectivity.constants';
import {ConnectivityState} from './connectivity.reducer.types';

const initialState: ConnectivityState = {
	isOnline: null,
};

export const connectivityReducer = (previousState = initialState, action): ConnectivityState => {
	if (action.type.endsWith(FAILURE_POSTFIX) && action.payload?.name === 'RequestError') {
		return {
			...previousState,
			isOnline: false,
		};
	}

	switch (action && action.type) {
		case CHECK_CONNECTION_SUCCESS:
			return {
				...previousState,
				isOnline: true,
			};
			break;

		case CHECK_CONNECTION_FAILURE:
			return {
				...previousState,
				isOnline: false,
			};
			break;

		case SET_OFFLINE:
			return {
				...previousState,
				isOnline: false,
			};
			break;

		case SET_ONLINE:
			return {
				...previousState,
				isOnline: true,
			};
			break;
		default:
			return previousState;
	}
};
